import React from 'react';
import { observer } from 'mobx-react-lite';
import { UserProps } from "../stores/user_store";
import { RootStoreContext } from '../stores/root_store';
import LoadingScreenBig from 'components/LoadingScreenBig';

import localforage from 'localforage';

type AuthContextType = {
    currentUser: UserProps,
    token: string,
    refreshCurrentUser: () => Promise<any>;
    updateCurrentUser: (user: UserProps) => void;
    updateAuthToken?: (token: string) => Promise<any>;
    isMe: (key_or_uuid: string) => boolean;
    isAuthenticated: boolean;
    checkingAuth: boolean;
}

const AuthContext = React.createContext<AuthContextType>({
    currentUser: {} as UserProps,
    updateCurrentUser: () => { throw "not implemented" },
    refreshCurrentUser: () => { throw "not implemented" },
    token: "",
    isAuthenticated: false,
    isMe: () => false,
    checkingAuth: true
});

const AuthProvider = observer(({ children }: { children: React.ReactNode  })=> {
    const [loading, setLoading] = React.useState(true);
    const [checkingAuth, setCheckingAuth] = React.useState(true);
    const [currentUser, setCurrentUser] = React.useState<UserProps>({} as UserProps);
    const [token, setToken] = React.useState('');

    const rootStore = React.useContext(RootStoreContext);

    function updateAuthToken(token: string) {
        setToken(token); // local
        return new Promise<string>((resolve, reject) => {
            localforage.setItem("access_token", token)
                .then((o) => {
                    console.log("resolved! woth o %o", o);
                    console.log("resolved! woth token %o", token);
                    resolve(token)
                })
                .catch(reject);
        });
    }

    function updateCurrentUser(user: UserProps) {
        // This is pretty trustworthy, but it turns out we don't use
        // the user object that much.  We use it to display the
        // current minutes, tasks, login email, phone number
        // Everything else is in Identity objects.
        if(user.uuid === currentUser.uuid || user.key === currentUser.key) {
            setCurrentUser(user);
        }
    }

    async function refreshCurrentUser() {
        return rootStore.userStore.loadCurrentUser()
            .then((u) => {
                if (u) {
                    setCurrentUser(u);
                }
            })
        .finally(() => {
            setCheckingAuth(false);
        });
    }

    React.useEffect(() => {
        if (token) {
            refreshCurrentUser();
        }
    }, [rootStore.userStore, token]);

    // React.useEffect(() => {
    //     const u = knownUsers.find((u) =>u.uuid == currentUser.uuid);
    //     console.log("known usrs search");
    //     if (u) {
    //         updateCurrentUser(u);
    //     }
    // }, [knownUsers, currentUser]);

    React.useEffect(() => {
        try {
            localforage
                .getItem<string>("access_token")
                .then((token) => {
                    if (token) {
                        setToken(token);
                    }
                    else {
                        setCheckingAuth(false);
                    }
                });
        }
        catch (err) {
            console.log("error : %o", err);
        }
        setLoading(false);
    }, []);

    // 🚨 this is the important bit.
    if (loading) {
        return <LoadingScreenBig />;
    }

    // const login = () => {} // make a login request
    // const register = () => {} // register the user
    // const logout = () => {} // clear the token in localStorage and the user data

    function isMe(key_or_uuid: string) {
        return (
            key_or_uuid === currentUser.key ||
                key_or_uuid === currentUser.uuid ||
                key_or_uuid === currentUser.ogkey
        );
    }

    // note, I'm not bothering to optimize this `value` with React.useMemo here
    // because this is the top-most component rendered in our app and it will very
    // rarely re-render/cause a performance problem.
    const data = {
        currentUser,
        updateCurrentUser,
        updateAuthToken,
        token,
        isAuthenticated: !!token,
        checkingAuth,
        refreshCurrentUser,
        isMe
    };
    return (
        <AuthContext.Provider value={data}>{ children }</AuthContext.Provider>
    )
});

// const useAuth = () => React.useContext(AuthContext);

export {AuthProvider, AuthContext}
